import React, { Component } from "react";
import axios from "axios";
import { selectVertualMovies } from "../redux/movies/movies.selector";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectLoadingStatus } from "./../redux/movies/movies.selector";
import Table from "./tableComponent/table";
import AddToAF from "./tableComponent/adToAf";

class MoviesSyncTable extends Component {
  state = {
    africanmovies: [],
  };
  columns = [
    { title: "Title", path: "title" },
    { title: "Genre", path: "genre" },
    { title: "Actor", path: "actor" },
    { title: "Language", path: "language" },
    {
      title: "Add To African Movies",
      buttons: (movie) => (
        <AddToAF movie={movie} label="Add To African Movies" />
      ),
      className: "tc-center",
    },
  ];

  searchMovie = (filterWord) => {
    const filtered = this.state.africanmovies.filter((movie) =>
      movie.title.toLowerCase().startsWith(filterWord.toLowerCase()),
    );
    this.setState({ africanmovies: filtered });
  };

  async componentDidMount() {
    const { data } = await axios.get(process.env.REACT_APP_API_ZC_MOVIES);
    this.setState({ africanmovies: data });
  }
  render() {
    const afTitles = [];
    const { movies: afmovies } = this.props;
    afmovies.map((v) => afTitles.push(v.videoId));

    const syncMovies = this.state.africanmovies.filter(
      (a) => !afTitles.includes(a.videoId),
    );

    return (
      <React.Fragment>
        <Table
          elements={syncMovies}
          columns={this.columns}
          search={this.searchMovie}
          title="All Africanmovies movies Unavailable in African Movies"
          show="af_search"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  movies: selectVertualMovies,
  isLoading: selectLoadingStatus,
});

export default connect(mapStateToProps)(MoviesSyncTable);
